import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';


// Servicios para componentes auxiliares
// import { SortableColumnService } from './sortableColumn.service';
import { SortableTableDirective } from './sortableColumn.directive';
import { SortableColumnComponent } from './sortableColumn.component';

@NgModule({
  declarations: [
    SortableTableDirective,
    SortableColumnComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SortableTableDirective,
    SortableColumnComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SortableColumnModule {
  constructor(
  ) {}

}